import { i18n } from '@/translate/i18n';

const zodiacAnimals = i18n.t('zodiacCards', {
  returnObjects: true,
});
export const animalsData = Object.values(zodiacAnimals);
